// import collect from 'collect.js';
// var calpak = window.calpak

const filterGroupList = document.querySelector(
  ".collection-filter__color-list"
);
const currentFilters = document.querySelector(".current-filters-list");

function renderColorGroups(productIDs) {
  const filteredContainers = document.querySelectorAll('.shopify-section--product-grid:has(.enabled-filtering)');

  if (filteredContainers.length == 0) {
    console.error("Nothing to filter!");
    return false;
  }
  let colors = []
  // console.log(productIDs)
  productIDs.forEach(
      (productId) => {
        const product = calpak.products.where('id', productId).first();
        if(product){
          const variants = calpak.collect(product.variants)
          const plucked = variants.pluck('option1');
          colors = colors.concat(plucked.all())
        }
      }
  )
  colors = calpak.collect(colors);
  colors = colors.unique().all();

  // console.log(colors)
  if(document.querySelector(".collection-filter__color-list-loading"))
    document.querySelector(".collection-filter__color-list-loading").style.display = "none";
  if(!filterGroupList)
    return;
  for (let color in calpak.color_groups) {
    let found = false;

    for (const colorShade of colors) {
      if (calpak.color_groups[color].indexOf(colorShade.toLowerCase().replace(/\s+/g, '-')) < 0) {
        continue
      }
      found = true;
      break;
    }
    // console.log(color)
    if (found) {
      let el = document.createElement("label");
      el.classList.add("filt-col-group");
      el.setAttribute("data-value", color);
      el.setAttribute("title", color);
      el.setAttribute("for", color);
      
      let elInput = document.createElement("input");
      elInput.setAttribute("title", color);
      elInput.classList.add("sr-only");
      elInput.setAttribute("type", "checkbox");
      elInput.setAttribute("data-value", color);
      elInput.setAttribute("value", color);
      elInput.setAttribute("id", color);
      elInput.setAttribute("name", color);

      el.appendChild(elInput);
      el.insertAdjacentHTML(
          "beforeend",
          `<span class="color-group color-group-${color}"></span>${color}`
      );
      filterGroupList.appendChild(el);
      setTimeout(customRadioButtonsFilter, 0);
    }
  }

  let colorFilterTriggerElement;

  const updateColorFilterTriggerElement = (e) => {
    if (e.target.classList.contains('filter__activator--color')) {
      colorFilterTriggerElement = e.target;
    } else {
      colorFilterTriggerElement = null;
    }
  };
  
  ['keydown', 'mousedown'].forEach(eventType => {
    document.addEventListener(eventType, updateColorFilterTriggerElement);
  });

  let isFiltering = false;
  let colGroupButtons = document.querySelectorAll(".filt-col-group");
  colGroupButtons.forEach((colGroupButton) =>
      colGroupButton.addEventListener("click", (e) => {
          e.preventDefault();
          if (isFiltering) return; 
          if(colorFilterTriggerElement && colorFilterTriggerElement.classList.contains('filter__activator--color')) return;

          isFiltering = true;
          const target = e.currentTarget;
          target.classList.toggle("filt-col-group--active");

          let input = target.querySelector('input');
          if (target.classList.contains("filt-col-group--active")) {
            if(input) input.checked = true;
          } else {
            if(input) input.checked = false;
          }
          
          applyFilter();

          setTimeout(() => {
            isFiltering = false;
          }, 300); 
      })
  );
}

function filterSetBestSellersOrder() {
  const filteredContainers = document.querySelectorAll('.shopify-section--product-grid:has(.enabled-filtering)');

  const collection = calpak.collections.where('handle', 'best-sellers').first();
  collection.products.forEach((productId, index) => {
    filteredContainers.forEach(container=>{
      let matchingProds = container.querySelectorAll(
          `.product-unit[data-id="${productId}"]`
      );
      matchingProds.forEach((matchingProd) =>
          matchingProd.style.setProperty("--ord-best", index)
      );
    })
  })
}

function filterSetDateOrder(unitSelects) {
  let unitSelectsOrdered = unitSelects.sort((a, b) => {
    let aCreated = 0;
    if (a.hasAttribute("data-created")) {
      aCreated = a.getAttribute("data-created") * 1;
    }

    let bCreated = 0;
    if (b.hasAttribute("data-created")) {
      bCreated = b.getAttribute("data-created") * 1;
    }

    if (aCreated < bCreated) return 1;
    if (aCreated > bCreated) return -1;
    return 0;

  });

  for (let i = 0; i < unitSelectsOrdered.length; i++)
    unitSelectsOrdered[i]
      .closest(".product-unit")
      .style.setProperty("--ord-date", i);
}

function filterSetPriceOrder(unitVariants) {
  let unitVariantsAsc = unitVariants.sort((a, b) => {
    let aPrice = 999,
      bPrice = 999;

    if (a.hasAttribute("data-max-price"))
      aPrice = a.getAttribute("data-max-price") * 1;
    if (b.hasAttribute("data-max-price"))
      bPrice = b.getAttribute("data-max-price") * 1;

    if (aPrice > bPrice) return 1;
    if (aPrice < bPrice) return -1;
    return 0;
  });

  for (let i = 0; i < unitVariantsAsc.length; i++) {
    let unit = unitVariantsAsc[i].closest(".product-unit");
    unit.style.setProperty("--ord-pra", i);
    unit.style.setProperty("--ord-prd", unitVariantsAsc.length - i);
  }
}

function initCollectionSort(productVariantSelects) {
  let unitVariants = Array.prototype.slice.call(productVariantSelects, 0);

  filterSetBestSellersOrder();
  filterSetDateOrder(unitVariants);
  filterSetPriceOrder(unitVariants);

  const sortInputs = document.querySelectorAll(
    '.collection-filter__sort input[name="sort"]'
  );
  sortInputs.forEach((sortInput) =>
    sortInput.addEventListener("click", () => {
      const selectedSort = document.querySelector(
        '.collection-filter__sort input[name="sort"]:checked'
      );
      if (selectedSort) {
        const sortValues = document.querySelectorAll(
          ".filter__activator--sort i, .collection-filter__sort .collection-filter__title i"
        );
        sortValues.forEach(
          (sortValue) =>
            (sortValue.innerHTML = `(${selectedSort.getAttribute("data-title")})`)
        );
      }

      applyFilter();
    })
  );
}

const initFilter = function() {
  // console.log('initFilter')
  const filteredContainers = document.querySelectorAll('.shopify-section--product-grid:has(.enabled-filtering)');
  filteredContainers.forEach(container=>{
    const products = container.querySelectorAll(".template-collection .product-unit.activate-js");
    for (const product of products) {
      setTimeout(() => calpak.activateProductUnit(product), 10)
    }
  })
  const filters = document.querySelector(".collection-filters");
  if (filters) filters.classList.add("collection-filters--loaded");

  const collection = calpak.collections.where('handle', calpak.collection).first();
  if (typeof collection !== 'undefined'){
    if(filterGroupList)
      renderColorGroups(collection.products);
  }
  else{
    // console.log(calpak.collection, 'window.calpak.collection doesn\'t exist. Collection skips if collection.image == blank or collection.description contains "hide in search"')
  }

  filteredContainers.forEach(container=>{
    const productVariantSelects = container.querySelectorAll(
        ".product-unit .product-unit__swatches"
    );
    let variantSelects = [];
    variantSelects.push(...productVariantSelects)
    initCollectionSort(variantSelects);
  })
  setTimeout(()=>{
    const request_args = location.pathname.split("/");
    if(request_args.length == 4){
      const applied_filters = request_args[3].split("+");
      applied_filters.forEach(function(filter){
        // check if valid color filter
        if(document.querySelector(".filt-col-group[data-value='"+filter+"']") != null){
          document.querySelector(".filt-col-group[data-value='"+filter+"']").click();
        }
      })
    }
  }, 300)
}
calpak.initFilter = initFilter
async function filterUnitByColor(product, colors) {
  /**
   * CHCECK IF COLORS LENGHT > 1
   * CLONE THE PRODUCT COLORS LENGTH TIMES
   * *ISSUE EVENT LISTENERS*
   * CHECK THE RESPECTIVLY SWATCH FOR EACH CLONE
   */

  const unitColors = product.querySelectorAll(".color-swatch");
  let unitColorValues = [];

  unitColors.forEach((unitColor) => {
    if (unitColor.classList.contains("product-option--na"))
      unitColorValues.push(unitColor.getAttribute("data-value"));
    else unitColorValues.unshift(unitColor.getAttribute("data-value"));
  });

  let found = false;
  var commoncolor = [];

  for (let j = 0; j < colors.length; j++) {
    const activeColorValue = colors[j];
    commoncolor.push(...calpak.color_groups[activeColorValue]);
  }
  const uniqueSet = new Set(commoncolor);
  commoncolor = Array.from(uniqueSet);
  
  unitColorValues = Array.from(new Set(unitColorValues));

  for (let k = 0; k < unitColorValues.length; k++) {
    const unitColorValue = unitColorValues[k];

    if (commoncolor && commoncolor.indexOf(unitColorValue) > -1) {
      const selectedSwatch = product.querySelector(".color-swatch--bundled") ? product.querySelector(
        `.color-swatch[data-option1="${unitColorValue}"][data-option2="${unitColorValue}"]`
      ) : product.querySelector(
        '.color-swatch[data-value="' + unitColorValue + '"]'
      );

      if (!selectedSwatch.classList.contains('product-option--na')) {
        if (!found) {
          found = true;
          selectedSwatch.classList.add("color-swatch--filter");
          setTimeout(() => {
            calpak.selectThisColorSwatch(selectedSwatch);
          }, 10);
        } else {
          if (!product.getAttribute("data-clone")) {
            let newProduct = product.insertAdjacentElement(
              "afterend",
              product.cloneNode(true)
            );
            newProduct.setAttribute("data-clone", true);
            let newSelectedSwatch = newProduct.querySelector(".color-swatch--bundled") ? newProduct.querySelector(
              `.color-swatch[data-option1="${unitColorValue}"][data-option2="${unitColorValue}"]`
            ) : newProduct.querySelector(
              '.color-swatch[data-value="' + unitColorValue + '"]'
            );
            newSelectedSwatch.classList.add("color-swatch--filter");
            setTimeout(() => {
              calpak.selectThisColorSwatch(newSelectedSwatch);
            }, 10);
          }
        }
      }
    }
  }

  if (found == false) {
    if(!product.parentElement?.classList.contains("monochrome-product-grid"))
      product.classList.add("product-unit--filtered-out");
  }
}

function updateCurrentFilters(colors = []) {
  let currentFiltersInnerHTML = ""
  if (colors.length > 0) {
    colors.forEach((color) => {
      let colorEl = `<li><button title="Remove" aria-label="Remove ${color} from active filters" class="current-filter" data-value="${color}">
                <div class="color-group color-group-${color}"></div>
                <div class="current-filter__remove"></div>
            </button></li>`;
      currentFiltersInnerHTML += colorEl;
    });
  }
  currentFilters.innerHTML = currentFiltersInnerHTML;
}

async function getProductsFilteredByCategory() {
  return new Promise(async (resolve) => {
    const filteredContainer = document.querySelector('.shopify-section--product-grid:has(.enabled-filtering)');

    let filteredProducts = false;

    let activeCollection = document.querySelector(
      ".filter__collection--selected"
    );
    if (!activeCollection)
      activeCollection = document.querySelector(
        ".collections-category--active"
      );
    let subCol = false;
    if (activeCollection) {
      subCol = activeCollection.classList.contains("filter__collection--sub");

      if (
        subCol ||
        ((activeCollection.hasAttribute("data-products") || activeCollection.hasAttribute("data-collection"))  &&
          activeCollection.classList.contains("filter__collection"))
      ) {
        let productList = [];

        if (activeCollection.hasAttribute("data-products")) {
          productList = activeCollection
            .getAttribute("data-products")
            .split(",");
        } else if (activeCollection.hasAttribute("data-collection")) {
          const collectionList = await fetch(
            `/collections/${activeCollection.getAttribute(
              "data-collection"
            )}/products.json?limit=250`
          ).then((response) => response.json());

          collectionList.products.forEach((product) =>
            productList.push(product.id + "")
          );
          activeCollection.setAttribute("data-products", productList.join(","));
        }

        if (subCol && filteredProducts) {
          let updatedList = [];
          productList.forEach((product) => {
            if (filteredProducts.indexOf(product) > -1)
              updatedList.push(product);
          });
          filteredProducts = updatedList;
        } else filteredProducts = productList;
      } else {
        if (activeCollection.hasAttribute("data-collection")) {
          let collectionHandle =
            activeCollection.getAttribute("data-collection");
          const pageHeader = document.querySelector(
            ".shopify-section--page-header"
          );
          const sections = [
            filteredContainer
              .getAttribute("id")
              .replace("shopify-section-", ""),
            pageHeader.getAttribute("id").replace("shopify-section-", ""),
          ];

          // const sectionContents = await fetch(
          //   `/collections/${activeCollection.getAttribute(
          //     "data-collection"
          //   )}?sections=${sections.join(",")}`
          // ).then((response) => response.json());

          // const oldUnits = filteredContainer.querySelectorAll(".product-unit");
          // oldUnits.forEach((oldUnit) => {
          //       if (typeof calpak.productUnitsObserver.unobserve === "function") {
          //         calpak.productUnitsObserver.unobserve(oldUnit)
          //       }
          //     }
          // );

          // const newUnits = new DOMParser()
          //   .parseFromString(sectionContents[sections[0]], "text/html")
          //   .querySelector(".product-grid").innerHTML;
       //   filteredContainer.querySelector(".product-grid").innerHTML = newUnits;

       //   console.log(collectionHandle);

          const dailyDealsSection = document.querySelector(
            ".shopify-section-daily-deals"
          );
          if (dailyDealsSection) {
            const collectionList = dailyDealsSection.getAttribute(
              "data-collection-list"
            );
            if (collectionList.includes(collectionHandle)) {
              dailyDealsSection.classList.remove("hide");
            } else {
              dailyDealsSection.classList.add("hide");
            }
          }

          const splitSection = document.querySelector(".collection-split-wrap");
          if (splitSection) {
            const collectionList = splitSection.getAttribute(
              "data-collection-list"
            );
            if (collectionList.includes(collectionHandle)) {
              splitSection.classList.remove("hide");
            } else {
              splitSection.classList.add("hide");
            }
          }

          const tolstoySection = document.querySelector(
            ".tolstoy-carousel-early-bf"
          );
          if (tolstoySection) {
            if (collectionHandle == "early-black-friday-deals") {
              tolstoySection.classList.remove("hide");
            } else {
              tolstoySection.classList.add("hide");
            }
          }

          // const productUnits =
          //   filteredContainer.querySelectorAll(".product-unit");
          // productUnits.forEach((productUnit) => {
          //   const qv = productUnit.querySelector(".quick-view__link");
          //   if (qv) qv.addEventListener("click", calpak.quickViewClick);
          // });

          // if(monochromeFilteredContainer != null){
          //   const monochromeSections = [
          //     monochromeFilteredContainer
          //       .getAttribute("id")
          //       .replace("shopify-section-", ""),
          //     pageHeader.getAttribute("id").replace("shopify-section-", ""),
          //   ];
          //
          //   const monochromeSectionContents = await fetch(
          //     `/collections/${activeCollection.getAttribute(
          //       "data-collection"
          //     )}?sections=${monochromeSections.join(",")}`
          //   ).then((response) => response.json());
          //
          //   const monochromeOldUnits = monochromeFilteredContainer.querySelectorAll(".product-unit");
          //   monochromeOldUnits.forEach((oldUnit) =>
          //     productUnitsObserver.unobserve(oldUnit)
          //   );
          //
          //   const monochromeNewUnits = new DOMParser()
          //     .parseFromString(monochromeSectionContents[sections[0]], "text/html")
          //     .querySelector(".product-grid").innerHTML;
          //     monochromeFilteredContainer.querySelector(".product-grid").innerHTML = monochromeNewUnits;
          //
          //
          //   const monochromeProductUnits =
          //   monochromeFilteredContainer.querySelectorAll(".product-unit");
          //   monochromeProductUnits.forEach((productUnit) => {
          //     const qv = productUnit.querySelector(".quick-view__link");
          //     if (qv) qv.addEventListener("click", calpak.quickViewClick);
          //   });
          // }

          // const newHeader = new DOMParser()
          //   .parseFromString(sectionContents[sections[1]], "text/html")
          //   .querySelector(".page__header").innerHTML;

          // document.querySelector(".page__header").innerHTML = newHeader;
        }
      }
    }

    if (
      subCol ||
      (activeCollection && activeCollection.hasAttribute("data-products"))
    )
      resolve(filteredProducts);
    else resolve(true);
  });
}

async function applyFilter(source = false) {
  // console.log('applyFilter')
  const filteredContainers = document.querySelectorAll('.shopify-section--product-grid:has(.enabled-filtering)');
  let productUnits = [];
  filteredContainers.forEach(container=>{
    const units = container.querySelectorAll(".product-unit");
    productUnits.push(...units);
  })
  // let monochromeProductUnits= [];
  // if(monochromeFilteredContainer != null){
  //   monochromeProductUnits = monochromeFilteredContainer.querySelectorAll(".product-unit");
  // }
  let filtered = false;

  [...productUnits].map((productUnit) => {
    if (productUnit.getAttribute("data-clone")) {
      productUnit.remove();
    }
  });

  // [...monochromeProductUnits].map((productUnit) => {
  //   if (productUnit.getAttribute("data-clone")) {
  //     productUnit.remove();
  //   }
  // });
  //// COLLECTIONS ////
  let filteredProducts = false;
  if (source == "collections") {
    filteredProducts = await getProductsFilteredByCategory();
    
    const selectedSubFilters = document.querySelectorAll('.filter__collection--selected');
    if (selectedSubFilters.length !== 0) {
      filtered = true;
    }
    else{
      filtered = false;
    }
  }

  
  if (filteredProducts !== false && source != "collections") {
    resetFilter();
    initFilter();
  }

  //// COLOR ////
  let activeColorValues = [];
  const activeColors = document.querySelectorAll(
    ".collection-filters .filt-col-group--active"
  );
  const colorNumbers = document.querySelectorAll(
    ".filter__activator--color i, .collection-filter__color .collection-filter__title i"
  );

  if (activeColors.length > 0) {
    filtered = true;

    activeColors.forEach((activeColor) => {
      activeColorValues.push(activeColor.getAttribute("data-value"));
      colorNumbers.forEach(
        (colorNumber) => (colorNumber.innerHTML = `(${activeColors.length})`)
      );
    });
  } else colorNumbers.forEach((colorNumber) => (colorNumber.innerHTML = ""));

  const request_args = location.pathname.split("/");
  let applied_filters = []
  
  if(request_args.length == 4)
  {
    applied_filters = request_args[request_args.length-1].split("+");
    applied_filters = applied_filters.filter(function(filter){
      if(calpak.color_groups[filter] == undefined && filter.trim() != ""){
        return true
      }
    })
  }
  

  applied_filters = [...applied_filters, ...activeColorValues]

  if(request_args.length == 4)
    request_args[request_args.length-1] = applied_filters.join("+");
  else
    request_args.push(applied_filters.join("+"));
  if(request_args[request_args.length-1]=="")
    request_args.pop();
  window.history.replaceState(null, '', request_args.join("/") + window.location.search);


  
  let curCollection = calpak.collections.items.filter(item=>item.handle == calpak.collection)[0];
  let collectionTitle = curCollection.title;
  let collectionProductSize = curCollection.products.length;
  let filterColor = ""
  let pageTitle = window.calpak.page_title;
  let pageDescription = window.calpak.page_description;
  let h1Title = collectionTitle;
  
  let canonicalUrl = ""

  if (activeColorValues.length == 1) {
    filterColor = calpak.capitalizeEachWord(calpak.unhandleize(activeColorValues[0]));
    pageTitle = `${filterColor} ${collectionTitle.replace("All", "").trim()}`;
    h1Title = `${filterColor} ${collectionTitle.replace("All", "").trim()}`;
    pageDescription = `Shop ${pageTitle} at CALPAK. Designed for your next adventure. Free shipping on US orders $75+"`;
    const availableCollections = ["bags", "luggage", "organizers"];

    let activeColor = activeColorValues[0];
    canonicalUrl = `https://www.calpaktravel.com/collections/${curCollection.handle}/${activeColor}`;

      if (Array.isArray(colorPlpContent) && colorPlpContent.length) {
        const matchingContent = colorPlpContent.find(content => content.collectionURL === canonicalUrl);

        if (matchingContent) updateContent(matchingContent.copyHeading, matchingContent.bottomCopy);
    }
  }
  else {
    pageTitle = window.calpak.page_title;
    pageDescription = window.calpak.page_description;
    canonicalUrl = `https://www.calpaktravel.com/collections/${curCollection.handle}`;
    
    updateContent(currentCopyContent, currentBottomCopy);
  }

  function updateContent(headerText, contentText) {
    const headerElement = document.querySelector(".plp-block-header");
    const contentElement = document.querySelector(".plp-block-content .text");

    if (headerElement) headerElement.innerHTML = headerText;
    if (contentElement) contentElement.innerHTML = contentText;
  }
 
  let enableMetaChange = false;
  if(document.querySelector(".page-title")?.dataset.enableMetaChange == "true")
    enableMetaChange = true

  if(enableMetaChange){

  if(document.querySelector(".page-title"))
    document.querySelector(".page-title").innerHTML = h1Title;
  const title = pageTitle.trim().endsWith("| CALPAK")
    ? pageTitle.trim()
    : pageTitle.trim() + " | CALPAK";

  document.title = title

  const metaDescription = document.querySelector('meta[name="description"]')
  if(metaDescription) metaDescription.setAttribute("content", pageDescription);

  const ogTitle = document.querySelector('meta[property="og:title"]');
  if(ogTitle) ogTitle.setAttribute("content", title);

  const ogDescription = document.querySelector('meta[property="og:description"]');
  if(ogDescription) ogDescription.setAttribute("content", pageDescription);

  const ogUrl = document.querySelector('meta[property="og:url"]')
  if(ogUrl) ogUrl.setAttribute("content", canonicalUrl);

  const twitterTitle = document.querySelector('meta[property="twitter:title"]');
  if(twitterTitle) twitterTitle.setAttribute("content", title);

  const twitterDescription = document.querySelector('meta[property="twitter:description"]');
  if(twitterDescription) twitterDescription.setAttribute("content", pageDescription);

  }

  
  let enableColorIndexing = false;

  if(document.querySelector(".page-title")&&document.querySelector(".page-title").dataset.enableColorIndexing == "true")
    enableColorIndexing = true

  if(activeColorValues.length > 0)
  {
    document.body.classList.add("filtered");
  }
  else{
    document.body.classList.remove("filtered");
  }

  //// APPLY FILTERS TO PRODUCTS ////
  let categoryProductCount = 0;
  for (let i = 0; i < productUnits.length; i++) {
    const product = productUnits[i];
    product.classList.remove("product-unit--filtered-out")
    const filteredColors = product.querySelectorAll(".color-swatch--filter");
    if (filteredColors.length > 0) {
      filteredColors.forEach((filteredColor) => {
        filteredColor.classList.remove("color-swatch--filter");
        filteredColor.classList.remove("color-swatch--active");
      });
      const firstColorElement = product.querySelector(".color-swatch--first");
      if (firstColorElement) {
        firstColorElement.classList.add("color-swatch--active");
      }
    }

    let unitColorValues = [];
    const url = window.location.href;
    const urlParts = url.split('/');
    const lastSegment = urlParts[urlParts.length - 1];
    let collection = document.querySelector(".product-grid .product-unit")?.getAttribute("data-collection");
    let isColumnsCollection = document.querySelector('#product-grid-sec.product-grid--breakdown');

    if (isColumnsCollection) {
      let colors = lastSegment.split('+');

      if (colors[colors.length - 1] === collection) {
        let allproducts = document.querySelectorAll(".product-grid .product-unit");
        allproducts?.forEach(product => {
          product.style.display = "block";
        });
      } else {
        let ele = document.querySelectorAll(".product-grid .product-unit");
        let colorSet = new Set(unitColorValues);

        ele.forEach((el) => {
          if(el.getAttribute("data-color")){
            let color = el.getAttribute("data-color").toLocaleLowerCase().replace(/\s+/g, '-');
            colorSet.add(color);
          }
        });
        unitColorValues = Array.from(colorSet);

        let keys = Object.keys(calpak.color_groups);
        for (let color of keys) {
          if (colors.includes(color)) {
            let group = calpak.color_groups[color];
            colors = colors.concat(group);
          }
        }

        let products = document.querySelectorAll(".product-grid .product-unit");
        products.forEach((product) => {
          if(product.getAttribute("data-color")){
            let datacolor = product.getAttribute("data-color").toLowerCase().replace(/\s+/g, '-');
            if (colors.includes(datacolor)) {
              product.style.display = "block";
            } else {
              product.style.display = "none";
            }
          }
        });
      }
    } else { 
      if (activeColorValues.length > 0){
        filterUnitByColor(product, activeColorValues);
      }
      else{
        const selectedSwatch = product.querySelector(
          '.color-swatch.color-swatch--active'
        );
        setTimeout(() => {
          calpak.selectThisColorSwatch(selectedSwatch);
        }, 10);
      }
    }
  }

  const slider = document.querySelector('.hot-deal-sale-products .slider--scrollbar');
  const sliderWrapper = document.querySelector('.hot-deal-sale-products .slider__wrapper.slider__wrapper--buttons-side');
  const productContainer = document.querySelector('.hot-deal-sale-products .slider');

  function checkIfScrollable() {
    if (productContainer && sliderWrapper && slider) {
      const visibleProducts = Array.from(productContainer.children).filter(product => {
        return window.getComputedStyle(product).display !== 'none';
      });

      const productWidth = visibleProducts?.length > 0 ? visibleProducts[0]?.offsetWidth : 0;
      const totalVisibleWidth = productWidth * visibleProducts?.length;

      const sliderWidth = slider.clientWidth;

      if (totalVisibleWidth > sliderWidth) {
        sliderWrapper.classList.remove('slider__wrapper--end');
      } else {
        sliderWrapper.classList.add('slider__wrapper--end');
      }
    }
  }

  const debounceCheckIFScrollable = calpak.debounce(checkIfScrollable, 200);

  debounceCheckIFScrollable();
  window.addEventListener('resize', debounceCheckIFScrollable);

  // for (let i = 0; i < monochromeProductUnits.length; i++) {
  //   const product = monochromeProductUnits[i];
  //   product.classList.remove("product-unit--filtered-out");
  //   const filteredColors = product.querySelectorAll(".color-swatch--filter");
  //   if (filteredColors.length > 0) {
  //     filteredColors.forEach((filteredColor) => {
  //       filteredColor.classList.remove("color-swatch--filter");
  //       filteredColor.classList.remove("color-swatch--active");
  //     });
  //     const firstColorElement = product.querySelector(".color-swatch--first");
  //     if (firstColorElement) {
  //       firstColorElement.classList.add("color-swatch--active");
  //     }
  //   }
  //
  //   if (activeColorValues.length > 0)
  //     filterUnitByColor(product, activeColorValues);
  //   if (
  //     filteredProducts !== false &&
  //     filteredProducts !== true &&
  //     filterUnitByProductList(product, filteredProducts)
  //   )
  //     categoryProductCount++;
  // }
  //// SORT ////
  const selectedSort = document.querySelector(
    '.collection-filter__sort input[name="sort"]:checked'
  );
  if (selectedSort) {
    filteredContainers.forEach(container=>{
      container.setAttribute("data-sort", selectedSort.value);
    })
  } else {
    filteredContainers.forEach(container=>{
      container.removeAttribute("data-sort");
    })
  }

  // if(monochromeFilteredContainer != null){
  //   if (selectedSort) {
  //     monochromeFilteredContainer.setAttribute("data-sort", selectedSort.value);
  //   } else monochromeFilteredContainer.removeAttribute("data-sort");
  // }
  //// ////
  updateCurrentFilters(activeColorValues);


  let filteredProductsCount = 0;
  
  filteredContainers.forEach(container=>{

    const activeProductsLeft = container.querySelectorAll(
      ".product-unit:not(.product-unit--filtered-out)"
    );
    if (activeProductsLeft.length == 0)
      container.classList.add("section-filtered--empty");
    else container.classList.remove("section-filtered--empty");
  
    if (filtered) container.classList.add("section-filtered");
    else container.classList.remove("section-filtered");
    filteredProductsCount = activeProductsLeft.length;
  })
  
  if(filteredProductsCount < 4)
  {
    let robotElement = document.querySelector("meta[name='robots']");
    if(robotElement == null){
      robotElement = document.createElement("meta");
    }
    robotElement.setAttribute("name", "robots");
    robotElement.setAttribute("content", "index, follow");
    document.querySelector('link[rel="canonical"]').after(robotElement);
  }
  // if(monochromeFilteredContainer != null){
    // const activeMonochromeProductsLeft = monochromeFilteredContainer.querySelectorAll(
    //   ".product-unit:not(.product-unit--filtered-out)"
    // );
    // if (activeMonochromeProductsLeft.length == 0)
    // monochromeFilteredContainer.classList.add("section-filtered--empty");
    // else monochromeFilteredContainer.classList.remove("section-filtered--empty");

    // if (filtered) monochromeFilteredContainer.classList.add("section-filtered");
    // else monochromeFilteredContainer.classList.remove("section-filtered");
  // }
  calpak.reloadStaticBlocks();

  let moreButton = document.querySelector(".moreButton");
  if (moreButton) {
    moreButton.addEventListener("click", function () {
      let moreButtonWrap = document.querySelector(".moreBTN_wrap");
      moreButtonWrap.classList.add("showFull");
    });
  }
}

function resetFilter() {
  const activeColors = document.querySelectorAll(".filt-col-group--active");
  if (activeColors.length > 0)
    activeColors.forEach((activeColor) =>
      activeColor.classList.remove("filt-col-group--active")
    );
}

const closeFilters = document.querySelectorAll(".filters__close");
if (closeFilters.length > 0) {
    closeFilters.forEach((closeFilter) => closeFilter.addEventListener("click", () => {
        const filters = closeFilter.closest(".collection-filters");

        if (filters.classList.contains("collection-filters-banner")) {
            document.querySelector(".shopify-section--collection-image-banner").classList.remove("banner-active");
        }
        
        const filterActivators = document.querySelectorAll(".filter__activator");
        filters.setAttribute("aria-expanded", false);
        filterActivators.forEach((filterActivator) => {
            filterActivator.setAttribute("aria-expanded", false); // Update aria-expanded on the button
            filterActivator.removeAttribute("aria-hidden");
        });
        filters.classList.remove("collection-filters--active");

        const filterbanner = document.querySelector(".collection-filters__control");
        filterbanner.classList.remove("collection-filters--open");

        const filtersection = document.querySelector(".collection-filters__section");
        filtersection.classList.remove("filter-opened");

        filters.activator?.focus();
    }));
}

const resetFilterButtons = document.querySelectorAll(".filter__reset");
if (resetFilterButtons.length > 0)
  resetFilterButtons.forEach((resetFilterButton) =>
    resetFilterButton.addEventListener("click", () => {
      resetFilter();
      applyFilter();
    })
  );

currentFilters?.addEventListener("click", function (e) {
  if (e.target.classList.contains("current-filter")) {
    const value = e.target.getAttribute("data-value");
    let target = document.querySelector(
      `.filt-col-group--active[data-value="${value}"]`
    );
    if (target) target.classList.remove("filt-col-group--active");

    applyFilter();
  }
});

function trappingColorFilterFocus() {
  let previousElement = document.activeElement || document.body;
  const firstFocusableElement = document.querySelector(
    "#collection-filters > div > fieldset > ul > li:nth-child(1) > fieldset > input"
  );
  const lastFocusableElement = document.querySelector(
    ".collection-filters .filters__close.close_btn"
  );
  const qvBody = document.querySelector("#collection-filters");
  if(qvBody){
    qvBody.addEventListener("keydown", function (e) {
      if (e.target === firstFocusableElement && e.key === "Tab" && e.shiftKey) {
        e.preventDefault();
        lastFocusableElement.focus();
      } else if (
        e.target === lastFocusableElement &&
        e.key === "Tab" &&
        !e.shiftKey
      ) {
        e.preventDefault();
        firstFocusableElement.focus();
      }
    });
  }
  if (lastFocusableElement) {
    lastFocusableElement.addEventListener("click", function (e) {
      previousElement.focus();
      previousElement = null;
    });
  }
}

// ADA custom radio JS solution - Product Unit

function customRadioButtonsFilter() {
  const swatchesKeyContainerUnit = document.querySelectorAll(
    ".collection-filter__color-list"
  );
  [].map.call(swatchesKeyContainerUnit, (container) => {
    calpak.customRadioKeyboardNav(container);
  });
}

// End ADA custom radio JS solution - Product Unit

const centerFilterCollection = () => {
  const filter_collection = document.querySelector(".filter__collections");
  if (filter_collection.scrollWidth == filter_collection.clientWidth) {
    filter_collection.style.justifyContent = "center";
  } else {
    filter_collection.style.justifyContent = "unset";
  }
}

document.addEventListener("calpak:loaded", () => {
  // console.log('filter calpak:loaded')

  initFilter()

  window.addEventListener("resize", centerFilterCollection)
  centerFilterCollection();

  setTimeout(() => {
    trappingColorFilterFocus();
  }, 100);

});

